import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  CalendarDays,
  CircleDollarSign,
  Store,
} from "lucide-react";
import { formatCurrency } from "./stuffAdapters";
import "./OffersPage.css";

const OfferDetails = () => {
  const navigate = useNavigate();

  return (
    <section className="offers-page">
      <section className="offers-sheet">
        <header className="offers-sheet-header">
          <div>
            <span>OFFER DETAILS</span>
            <h2 id="offers-sheet-title">Salar Shopping Voucher</h2>
          </div>
          <button
            type="button"
            onClick={() => navigate("/Offers")}
            aria-label="Back to offers"
          >
            <ArrowLeft size={19} strokeWidth={2} />
          </button>
        </header>

        <div className="offers-sheet-status-row">
          <span className="offers-status offers-status-active">Active</span>
          <span>
            <CalendarDays size={14} strokeWidth={2} />
            01-08-2025
          </span>
        </div>

        <section className="offers-sheet-product">
          <div className="offers-sheet-product-image">
            <img
              src="../../assets/img/mobiles/mobiles-4.png"
              alt="Salar Shopping Voucher"
            />
          </div>
          <div>
            <span>PRODUCT</span>
            <h3>Salar Shopping Voucher</h3>
            <p>Special in-store electronics offer.</p>
            <strong>{formatCurrency(22000)}</strong>
          </div>
        </section>

        <section className="offers-sheet-card">
          <div className="offers-sheet-section-title">
            <span>
              <CircleDollarSign size={17} strokeWidth={2} />
            </span>
            <h3>Offer Information</h3>
          </div>
          <div className="offers-sheet-detail-grid">
            <div>
              <span>Date</span>
              <strong>01-08-2025</strong>
            </div>
            <div>
              <span>Purchase Type</span>
              <strong>Instore</strong>
            </div>
            <div>
              <span>Price</span>
              <strong>{formatCurrency(22000)}</strong>
            </div>
            <div>
              <span>Category</span>
              <strong>Electronics</strong>
            </div>
            <div>
              <span>Status</span>
              <span className="offers-status offers-status-active">
                Active
              </span>
            </div>
            <div>
              <span>Discount</span>
              <strong>10%</strong>
            </div>
            <div>
              <span>Quantity</span>
              <strong>1 item</strong>
            </div>
            <div>
              <span>Expires In</span>
              <strong>1 Year</strong>
            </div>
          </div>
        </section>

        <section className="offers-sheet-card">
          <div className="offers-sheet-section-title">
            <span>
              <Store size={17} strokeWidth={2} />
            </span>
            <h3>Seller Information</h3>
          </div>
          <div className="offers-sheet-seller-list">
            <div>
              <span>Seller Store Name</span>
              <strong>KBK Stores</strong>
            </div>
            <div>
              <span>Seller Store ID</span>
              <strong>SNM1223455GH</strong>
            </div>
          </div>
        </section>
      </section>
    </section>
  );
};

export default OfferDetails;
